import { action, observable } from 'mobx';
import {ConfirmModalParams, ModalParams} from 'core/models';

class ModalStore {
    @observable accessor confirmParams = new ConfirmModalParams({});
    @observable accessor modalParams = new ModalParams({});

    constructor(rootStore) {

        this.rootStore = rootStore;
    }

    @action
    showConfirm(message, onConfirm, onCancel) {
        this.confirmParams.setCallbacks({
            onConfirm,
            onCancel
        });

        this.confirmParams.open({
            message
        });
    }

    @action
    showModal() {
        this.modalParams.open();

    }
}

export default ModalStore;
